import { ErrorHandler, Injectable } from '@angular/core';
import { logger } from '@mpt-fo/common/telemetry';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	handleError(error: any): void {
		const isExpiredToken = error?.toString()?.includes('User Token Expired');
		if (isExpiredToken) {
			return;
		}
		logger.error(error);

		const chunkFailedMessage = /Loading chunk [\d]+ failed/;
		if (chunkFailedMessage.test(error.message)) {
			window.location.reload();
		}
	}
}
